import { Image } from 'antd';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import OptionalImage1 from '../../../../../assets/images/userSellTractor/user_sell_tractor_image_tip_optional_1.jpg';
import OptionalImage2 from '../../../../../assets/images/userSellTractor/user_sell_tractor_image_tip_optional_2.jpg';
import OptionalImage3 from '../../../../../assets/images/userSellTractor/user_sell_tractor_image_tip_optional_3.jpg';
import OptionalImage4 from '../../../../../assets/images/userSellTractor/user_sell_tractor_image_tip_optional_4.jpg';
import OptionalImage5 from '../../../../../assets/images/userSellTractor/user_sell_tractor_image_tip_optional_5.jpg';
import OptionalImage6 from '../../../../../assets/images/userSellTractor/user_sell_tractor_image_tip_optional_6.jpg';
import RequiredImage1 from '../../../../../assets/images/userSellTractor/user_sell_tractor_image_tip_required_1.jpg';
import RequiredImage2 from '../../../../../assets/images/userSellTractor/user_sell_tractor_image_tip_required_2.jpg';
import RequiredImage3 from '../../../../../assets/images/userSellTractor/user_sell_tractor_image_tip_required_3.jpg';
import RequiredImage5 from '../../../../../assets/images/userSellTractor/user_sell_tractor_image_tip_required_5.jpg';

const REQUIRED_IMAGES = [
  { src: RequiredImage1, description: '좌(또는 우)측면' },
  { src: RequiredImage2, description: '정면' },
  { src: RequiredImage3, description: '후면' },
  { src: RequiredImage5, description: '실내' },
];

const OPTIONAL_IMAGES = [
  { src: OptionalImage1, description: '앞 타이어' },
  { src: OptionalImage2, description: '뒷 타이어' },
  { src: OptionalImage3, description: '작업기' },
  { src: OptionalImage4, description: '기타 1' },
  { src: OptionalImage5, description: '기타 2' },
  { src: OptionalImage6, description: '기타 3' },
];

export const SellTractorSurveyImageExample = () => {
  return (
    <Container>
      <TitleSection>
        <Title>{'📸 사진 예시'}</Title>
        <Description>{'측면, 정면, 후면, 실내가 잘 보이도록\n총 4장의 사진을 찍어주세요.'}</Description>
      </TitleSection>

      <ExamplePhotoSection>
        <ExamplePhotoTitle>{'필수 사진'}</ExamplePhotoTitle>

        <CustomSwiper
          // 페이지 가로 너비에 따라서 한 Page에서 보여줄 Slide 수 계산
          slidesPerView={
            document.documentElement.clientWidth > 512 ? 512 / 226 : document.documentElement.clientWidth / 226
          }
          // 슬라이드 사이의 간격
          spaceBetween={16}
        >
          {REQUIRED_IMAGES.map((requiredImage) => (
            <CustomSwiperSlide>
              <ExampleImage src={requiredImage.src} className={'full-w-h'} />
              <ImageDescriptionBackground>
                <ImageDescription>{requiredImage.description}</ImageDescription>
              </ImageDescriptionBackground>
            </CustomSwiperSlide>
          ))}
        </CustomSwiper>
      </ExamplePhotoSection>

      <ExamplePhotoSection>
        <ExamplePhotoTitle>{'선택 사진'}</ExamplePhotoTitle>

        <CustomSwiper
          // 페이지 가로 너비에 따라서 한 Page에서 보여줄 Slide 수 계산
          slidesPerView={
            document.documentElement.clientWidth > 512 ? 512 / 226 : document.documentElement.clientWidth / 226
          }
          // 슬라이드 사이의 간격
          spaceBetween={16}
        >
          {OPTIONAL_IMAGES.map((optionalImage) => (
            <CustomSwiperSlide>
              <ExampleImage src={optionalImage.src} className={'full-w-h'} />
              <ImageDescriptionBackground>
                <ImageDescription>{optionalImage.description}</ImageDescription>
              </ImageDescriptionBackground>
            </CustomSwiperSlide>
          ))}
        </CustomSwiper>
      </ExamplePhotoSection>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  padding: 0px var(--radius-large, 16px) 0px var(--radius-large, 16px);
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  gap: var(--radius-small, 4px);
`;

const Title = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;

const Description = styled.pre`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const ExamplePhotoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  gap: var(--radius-small, 4px);
`;

const ExamplePhotoTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);

  /* Display/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 18.2px */
`;

const CustomSwiper = styled(Swiper)`
  width: calc(100% + 32px);

  padding: 0px 16px;

  transform: translateX(-16px);

  gap: 16px;
`;

const CustomSwiperSlide = styled(SwiperSlide)`
  width: 200px;
  height: 140px;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: var(--radius-medium, 8px);

  border-radius: var(--radius-medium, 8px);

  cursor: pointer;

  position: relative;

  overflow: hidden;
`;

const ExampleImage = styled(Image)`
  border-radius: var(--radius-medium, 8px) !important;
`;

const ImageDescriptionBackground = styled.div`
  width: 100%;
  height: 36px;

  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  padding: 12px 0px;
  gap: 10px;

  background: rgba(38, 36, 41, 0.6);

  position: absolute;

  left: 0px;
  bottom: 0px;

  border-radius: 0px 0px 8px 8px;

  pointer-events: none;
`;

const ImageDescription = styled.span`
  color: #fff;

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
